import { PlusIcon } from 'lucide-react'
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

import { ComboboxTrigger } from '@/components/atoms/combobox-trigger.atom'
import { cn } from '@/lib/utils'

export interface ToolSelectorTriggerProps
  extends Omit<ComponentPropsWithoutRef<'button'>, 'disabled'> {
  placeholder: string
  isOpen: boolean
  isDisabled: boolean
}

/**
 * Trigger button for the tool selector combobox.
 * Shows a plus icon with placeholder text.
 */
export const ToolSelectorTrigger = forwardRef<HTMLButtonElement, ToolSelectorTriggerProps>(
  ({ placeholder, isOpen, isDisabled, className, ...rest }, ref): ReactNode => (
    <ComboboxTrigger
      ref={ref}
      isOpen={isOpen}
      isDisabled={isDisabled}
      className={cn('tool-selector-trigger', className)}
      {...rest}
    >
      <span className="flex items-center gap-2 text-muted-foreground">
        <PlusIcon className="size-4" />
        {placeholder}
      </span>
    </ComboboxTrigger>
  )
)

ToolSelectorTrigger.displayName = 'ToolSelectorTrigger'
